/**
 * @module Icons
 * Icons for Features
 */

// const icons = require("../images/icons/features");
// const lottie = require('lottie-web');

export class Icons {

    constructor() {

        $('.features__list li').hover(
            function() {
                let icon = $(this).find('img');
                let iconHovered = icon.data('hover');
                icon.attr('src', iconHovered);
            },
            function() {
                let icon = $(this).find('img');
                let iconStatic = icon.data('static');
                icon.attr('src', iconStatic);
            }
            // animations[iconName].goToAndPlay(1, true);
        );

        if($('.as-why-sm')){
            $('.as-why-sm .features__list li').hover(
                function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    let icon = $(this).find('img');
                    let iconStatic = icon.data('static');
                    icon.attr('src', iconStatic);
                },
                function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                }
            );
        }

    }
}

